// Per-list sort persistence in sessionStorage (survives navigation + reloads
// within the tab session, cleared when the tab closes). One key per list type,
// independent. Column widths remain in each page's localStorage prefs; only the
// sort column + direction live here. Default is created_at desc for every list.

export type SortDir = "asc" | "desc";
export interface SortState {
  sort: string;
  dir: SortDir;
}

const DEFAULT: SortState = { sort: "created_at", dir: "desc" };

// Session keys — one per list type. Keep these stable; they are the identity of
// each list's remembered sort.
export const SORT_KEYS = {
  creators: "sort_creators",
  works: "sort_works",
  organizations: "sort_organizations",
  audit: "sort_audit",
  origins: "sort_origins",
  originEvents: "sort_origin_events",
  emailTemplates: "sort_email_templates",
} as const;

export function readSort(key: string): SortState {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return DEFAULT;
    const p = JSON.parse(raw);
    if (typeof p?.sort === "string" && (p.dir === "asc" || p.dir === "desc")) {
      return { sort: p.sort, dir: p.dir };
    }
  } catch {
    /* ignore malformed / unavailable storage */
  }
  return DEFAULT;
}

export function writeSort(key: string, state: SortState): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(state));
  } catch {
    /* ignore quota / unavailable storage */
  }
}
